import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { OptimiseRequest, EnqueueOptimisationResponse } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface EnqueueApiResponse {
  success: boolean;
  data: EnqueueOptimisationResponse;
}

export function useEnqueueOptimisation(projectId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: OptimiseRequest) => {
      const response = await apiClient.post<EnqueueApiResponse>(
        `/projects/${projectId}/optimise`,
        body,
      );
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.optimisation.runs(projectId) });
    },
  });
}
